import React from 'react';

import Bull from '../../../components/BulletSeparator';
import {
  PrivacyPolicyLink,
  SelfServiceLink,
  SupportLink,
  UserNoticeLink,
} from '../../../components/links';
import { OidcContext } from '../../../types';
import { isMobileOidc } from '../../../utilities/oidc/oidc';
import { isFedM, isIsolatedCloud } from '../../../utilities/env';
import { useAnalyticsClient } from '../../../utilities/analytics/analytics-web-client';
import { loginPageId } from '../constants';

const Footer = ({
  isEmbedded,
  oidcContext,
}: {
  isEmbedded: boolean;
  oidcContext: OidcContext | undefined;
}) => {
  const analyticsClient = useAnalyticsClient();

  if (isEmbedded) return null;

  const showHelpLinks = isIsolatedCloud() || isFedM();

  return (
    <>
      {showHelpLinks && (
        <ul>
          <li>
            <SelfServiceLink
              onClick={() => analyticsClient.linkClickedEvent(loginPageId, 'loginHelpLink')}
            />
          </li>
          <Bull />
          <li>
            <SupportLink
              onClick={() => analyticsClient.linkClickedEvent(loginPageId, 'contactSupportLink')}
            />
          </li>
        </ul>
      )}
      <ul className="fine-print">
        <li>
          <PrivacyPolicyLink isMobileLink={isMobileOidc(oidcContext)} />
        </li>
        <Bull />
        <li>
          <UserNoticeLink isMobileLink={isMobileOidc(oidcContext)} />
        </li>
      </ul>
    </>
  );
};

export default Footer;
